import { useMutation } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AcceptOrganizationInvitationAuthenticatedDto } from "../../../models/organization/dto/accept-organization-invitation.dto";
import { OrganizationMemberDto } from "../../../models/organization/dto/organization.dto";

/**
 * One-click join for a user who is ALREADY signed in as the invitee. No
 * password — the API verifies the session email matches the invitation and
 * just creates the membership.
 *
 * Returns the created `OrganizationMemberDto`, whose `role` is the ONLY
 * trustworthy answer to "what is this user now". This endpoint deliberately
 * does NOT stamp the Firebase `role` custom claim (the claim is one global
 * value per user, so stamping `coach` here would clobber the same person's
 * admin claim in another org — see `accept-invitation-authenticated.ts`), so
 * the caller must not read the role off the token afterwards.
 */
export const useAcceptInvitationAuthenticated = () => {
    const apiClient = useApiClient();

    return useMutation({
        mutationKey: ['acceptInvitationAuthenticated'],
        mutationFn: async (dto: AcceptOrganizationInvitationAuthenticatedDto) => {
            return apiClient.fetchApi<OrganizationMemberDto, AcceptOrganizationInvitationAuthenticatedDto>({ method: 'POST', endpoint: 'organizations/accept-invitation/authenticated', body: dto });
        }
    });
};
